import EventAdaptingStateHandler from "src/states/EventAdaptingStateHandler"
import StateConstants from "src/states/StateContstants"

/**
 * Mirrors backend Permission. The frontend only ever reads these to decide what to
 * show — the backend refuses the request regardless, so a stale value here shows a
 * surface that then fails cleanly rather than granting anything.
 */
class UserPermissionHelper {
    static REPORT_VIEW = "report_view"
    static REPORT_CREATE = "report_create"
    static ANALYSIS_DASHBOARD_VIEW = "analysis_dashboard_view"
    static REFINED_VALUATION_VIEW = "refined_valuation_view"
    static REFINED_VALUATION_UPDATE = "refined_valuation_update"
    static REFINED_VALUATION_DELETE = "refined_valuation_delete"

    static ADMIN_ROLE = "admin"

    static hasPermission(stateHandler: EventAdaptingStateHandler, permission: string): boolean {
        const permissions: string[] = stateHandler.get(StateConstants.USER_PERMISSIONS) || []
        return permissions.includes(permission)
    }

    static hasPermissionIn(permissions: string[] | null | undefined, permission: string): boolean {
        return Array.isArray(permissions) && permissions.includes(permission)
    }

    static canViewAnalysisDashboard(stateHandler: EventAdaptingStateHandler): boolean {
        return UserPermissionHelper.hasPermission(
            stateHandler, UserPermissionHelper.ANALYSIS_DASHBOARD_VIEW
        )
    }
}

export default UserPermissionHelper
